import {EditorProps} from "react-data-grid";
import EditorComboboxBase from './base';
import React from "react";
import {StatusColoredOption} from "../../../Form/Combobox/Options";

const EditorComboboxColor = (props:EditorProps<any>) => {
    return <EditorComboboxBase {...props} OptionRender={StatusColoredOption} />
}

export default EditorComboboxColor